import React from "react";
import bgImage from "../image/image1.png";
import Navigation from "./Navbar";
import Footer from "./Footer";
import Slider from "./Slider";

/* =======================
   ICON IMPORTS (VERIFIED)
   ======================= */

import {
  HiOutlineGlobeAlt,
  HiOutlineChartBar,
  HiOutlineAcademicCap,
  HiOutlineOfficeBuilding,
  HiOutlineBeaker,
  HiOutlineTruck,
} from "react-icons/hi";

import {
  FaHeartbeat,
  FaHospitalUser,
  FaIndustry,
  FaCapsules,
  FaUserGraduate,
  FaHandshake,
} from "react-icons/fa";

import {
  MdHealthAndSafety,
  MdOutlineScience,
  MdOutlineVolunteerActivism,
} from "react-icons/md";

import { GiArtificialIntelligence } from "react-icons/gi";
import { Link } from "react-router-dom";


/* =======================
   DATA
   ======================= */

const focusAreas = [
  { title: "Public Health", icon: FaHeartbeat },
  { title: "Policy Astrology and Analytics", icon: HiOutlineChartBar },
  { title: "MedTech & SaMD", icon: GiArtificialIntelligence },
  { title: "Industry Leadership", icon: FaIndustry },
  { title: "Diagnostics & IVD", icon: HiOutlineBeaker },
  { title: "Digital Health", icon: MdHealthAndSafety },
  { title: "Health Finance & Insurance", icon: FaHospitalUser },
  { title: "Capacity Building (Viksit Bharat 2047)", icon: HiOutlineAcademicCap },
  { title: "Pharmaceuticals", icon: FaCapsules },
  { title: "Services Exports", icon: HiOutlineOfficeBuilding },
  { title: "Procurement & Supply Chain", icon: HiOutlineTruck },
  { title: "Skill Development", icon: FaUserGraduate },
  { title: "Organ Donation Endeavors", icon: MdOutlineVolunteerActivism },
  { title: "Genomics", icon: MdOutlineScience },
  
  // NEW ITEMS ADDED:
  { title: "Global Collaborations & Outreach", icon: HiOutlineGlobeAlt },
  { title: "HealthTech", icon: MdHealthAndSafety },
  { title: "Quality & Innovation", icon: FaIndustry },
  { title: "Start Ups & Sustainability", icon: HiOutlineChartBar },
  { title: "Industry-Academia-Govt Partnership", icon: FaHandshake },
  { title: "PwDs and Assistive Tech", icon: MdOutlineVolunteerActivism },
  { title: "Healthcare Journals", icon: HiOutlineAcademicCap },
  { title: "Health Economics & Statistics", icon: HiOutlineChartBar },
  { title: "Strategic Conferences and Conclaves", icon: HiOutlineOfficeBuilding },
  { title: "VUCA Watch", icon: HiOutlineGlobeAlt },
];

/* =======================
   COMPONENT
   ======================= */

const PolicyDialoguesFocus = () => {
  return (
    <div>
    {/* <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
        <Slider/>
      </div> */}
   <div className="fixed top-0 left-0 w-full bg-white shadow-md z-50">
    <Navigation/>
   </div>
    <section className="relative w-full min-h-screen overflow-hidden lg:pt-[145px] pt-[100px]">

      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${bgImage})` }}
      />

      {/* Overlay for readability */}
      <div className="absolute inset-0 bg-white/40"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 py-20 text-white">

        {/* ================= HEADER ================= */}
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold tracking-wide italic text-blue-900">
            POLICY DIALOGUES{" "}
            <span className="text-orange-600 italic">FOCUS</span>
          </h1>
          <p className="mt-4 text-lg md:text-xl max-w-4xl mx-auto opacity-90 italic text-blue-900">
            Driving Strategic Conversations for a Healthier & Sustainable Future
          </p>
        </div>

        {/* ================= FOCUS AREAS ================= */}
        <div className="relative rounded-2xl p-8 pt-14 text-slate-800 shadow-2xl"
         style={{
    background: "linear-gradient(60deg, rgba(191, 216, 238, 1), rgba(230, 238, 247, 1), rgba(183, 199, 214, 1))"
  }}
        >

  {/* 🔵 Floating Center Title */}
  <div className="absolute -top-8 lg:-top-6 left-1/2 -translate-x-1/2">
   <div
  className="flex items-center gap-2 text-white px-4 py-2 rounded-full shadow-lg"
  style={{
    background: "linear-gradient(90deg, rgba(35,106,170,1), rgba(11,62,121,1), rgba(19,89,156,1))"
  }}
>
      <HiOutlineAcademicCap className="text-orange-400 md:text-3xl text-xl" />
      <span className="text-sm lg:text-2xl font-semibold tracking-wide">
       <span className="italic text-white">
  Our Key <span className="font-semibold text-orange-600">Focus Areas</span>
</span>
      </span>
    </div>
  </div>

  {/* 🔵 Grid Content */}
  <div className="grid grid-cols-1  md:grid-cols-3 lg:grid-cols-4 gap-6 bg-[rgba(230,241,249)]">

    {focusAreas.map((item, index) => {
      const Icon = item.icon;
      return (
        <div
          key={index}
          className="group flex flex-col items-center text-center bg-slate-50 hover:bg-blue-50 transition rounded-xl p-5 shadow-sm hover:shadow-md"
        >
          <div className="w-14 h-14 flex items-center justify-center rounded-full bg-blue-900 text-orange-400 mb-4 group-hover:scale-110 transition">
            <Icon size={26} />
          </div>
          <p className="text-sm font-medium leading-snug">
            {item.title}
          </p>
        </div>
      );
    })}
  </div>

</div>


        {/* ================= CROSS-CUTTING THEMES ================= */}
       <div className="mt-16 grid md:grid-cols-2 gap-10">
  
  {/* Left - Always on top */}
 
<div className="relative bg-[rgba(217,229,238,1)] p-8 rounded-2xl w-full h-auto border border-slate-200 shadow-xl">
  {/* Cross-Cutting Themes pill overlapping */}
<div
  className="absolute -top-8 lg:-top-4 left-1/2 transform -translate-x-1/2 inline-flex items-center gap-2 text-white px-5 py-1.5 rounded-full shadow-lg"
  style={{
    background: "linear-gradient(90deg, rgba(35,106,170,1), rgba(11,62,121,1), rgba(19,89,156,1))"
  }}
>
  <FaHandshake className="text-orange-400 text-xl lg:text-2xl" />
  <h3 className="lg:text-lg font-semibold m-0 italic text-sm">Cross-Cutting Themes</h3>
</div>


  {/* Content with beautiful list items */}
  <div className="mt-10 pt-2">
    <ul className="space-y-4">
      <li className="flex items-center gap-3 group p-3 rounded-lg hover:bg-slate-50 transition-all duration-300">
        <div className="flex items-center justify-center w-8 h-8 bg-orange-50 rounded-full group-hover:bg-orange-100 transition-all">
          <FaHandshake className="text-orange-500 text-lg" />
        </div>
        <div className="flex-1">
          <span className="text-slate-800 font-medium">Equity & Inclusive Growth</span>
          <div className="h-0.5 w-full bg-gradient-to-r from-orange-400 to-transparent mt-1 opacity-60"></div>
        </div>
      </li>
      
      <li className="flex items-center gap-3 group p-3 rounded-lg hover:bg-slate-50 transition-all duration-300">
        <div className="flex items-center justify-center w-8 h-8 bg-orange-50 rounded-full group-hover:bg-orange-100 transition-all">
          <MdHealthAndSafety className="text-orange-500 text-lg" />
        </div>
        <div className="flex-1">
          <span className="text-slate-800 font-medium">Innovation & Sustainability</span>
          <div className="h-0.5 w-full bg-gradient-to-r from-orange-400 to-transparent mt-1 opacity-60"></div>
        </div>
      </li>
      
      <li className="flex items-center gap-3 group p-3 rounded-lg hover:bg-slate-50 transition-all duration-300">
        <div className="flex items-center justify-center w-8 h-8 bg-orange-50 rounded-full group-hover:bg-orange-100 transition-all">
          <HiOutlineGlobeAlt className="text-orange-500 text-lg" />
        </div>
        <div className="flex-1">
          <span className="text-slate-800 font-medium">Global Health Resilience</span>
          <div className="h-0.5 w-full bg-gradient-to-r from-orange-400 to-transparent mt-1 opacity-60"></div>
        </div>
      </li>
      
      <li className="flex items-center gap-3 group p-3 rounded-lg hover:bg-slate-50 transition-all duration-300">
        <div className="flex items-center justify-center w-8 h-8 bg-orange-50 rounded-full group-hover:bg-orange-100 transition-all">
          <FaIndustry className="text-orange-500 text-lg" />
        </div>
        <div className="flex-1">
          <span className="text-slate-800 font-medium">Public-Private Partnerships</span>
          <div className="h-0.5 w-full bg-gradient-to-r from-orange-400 to-transparent mt-1 opacity-60"></div>
        </div>
      </li>
    </ul>
  </div>
</div>


  {/* Right - Always below left on all screen sizes */}
<div className="bg-[rgba(217,229,238,1)] text-slate-800 rounded-2xl p-8 shadow-2xl lg:h-[55%]">
  <h4 className="text-xl font-semibold mb-4 flex flex-col gap-2">
    <span className="flex items-center gap-2 text-blue-900 font-bold italic">
      <HiOutlineGlobeAlt className="text-orange-500 text-3xl lg:text-xl" />
      Shaping Global Policies for Tomorrow
    </span>
    {/* Orange underline */}
    <span className="block h-1 w-20 bg-orange-500 rounded-full"></span>
  </h4>

  <p className="leading-relaxed">
   Advancing strategic dialogues to foster resilient health systems, innovation, and international collaboration aligned with {' '}
    <strong className="text-orange-500">Viksit Bharat 2047 </strong>and <strong className="text-blue-900">SDGs 2030.</strong>
  </p>
</div>
</div>

{/* last box */}
<div className="flex lg:ml-[490px] mt-10">
  <div className="inline-flex flex-col items-center gap-4 p-6 rounded-xl bg-blue-900/60">
    {/* Get Involved text */}
    <h3 className="text-white font-bold text-xl">Get Involved</h3>
    
    {/* Button with white border */}
    <Link to='/contact'>
    <button className="bg-gradient-to-r from-blue-900 via-blue-800 to-blue-900 text-white text-xl font-bold px-8 py-3 rounded-full hover:opacity-90 transition-opacity border-2 border-white">
      Collaborate with us →
    </button></Link>
  </div>
</div>

      </div>
      
    </section>
        <main
        className="relative z-10"  
        
      >
        <Footer />
      </main>
     </div>
  );
};

export default PolicyDialoguesFocus;